import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { PropTypes } from 'prop-types';
import { ProjectTypeToggle } from '~/modules/common/components/ProjectTypeToggle';
import ProjectsQuickFilterSummary from '~/modules/common/components/ProjectsQuickFilterSummary';
import { clientTag } from '~/modules/common/components/SearchBox/Facets/ClientFacet/tag';
import { useClientProjectsContext } from '../ClientProjectsContext';
import ProjectSearchBox from './ProjectSearchBox';

const useStyles = makeStyles(theme => ({
  toolBar: {
    display: 'flex',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1, 2, 1, 2),
    minHeight: '-webkit-fit-content',
    left: 0,
    right: 0,
    position: 'sticky',
    zIndex: theme.zIndex.appBar - 2,
    [theme.breakpoints.down('xs')]: {
      flexDirection: `column-reverse`,
      alignItems: 'flex-end',
      padding: theme.spacing(1, 2)
    }
  },
  projectTypeContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '40%',
      maxWidth: 120,
      padding: theme.spacing(0),
      '& span:last-child': {
        overflow: 'visible'
      }
    }
  }
}));

const useSearchStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1, 0, 0, 0),
      width: '100%'
    }
  }
}));

export const Toolbar = ({ client }) => {
  const classes = useStyles();
  const projectSearchStyles = useSearchStyles();

  const {
    projectType,
    onProjectTypeClick,
    searchCriteria,
    summaryFilterState,
    setSearchCriteria
  } = useClientProjectsContext();

  const mapSearchCriteria = useMemo(
    () => ({
      ...searchCriteria,
      criterions: {
        ...(searchCriteria.criterions || {}),
        [clientTag]: [{ value: client.id }]
      }
    }),
    [client.id, searchCriteria]
  );

  return (
    <>
      <div className={classes.toolBar}>
        {setSearchCriteria && (
          <ProjectSearchBox classes={projectSearchStyles} />
        )}
        <ProjectTypeToggle
          className={classes.projectTypeContainer}
          projectType={projectType}
          searchCriteria={mapSearchCriteria}
          onProjectTypeClick={onProjectTypeClick}
        />
      </div>
      <ProjectsQuickFilterSummary
        key={
          summaryFilterState.quickFilter &&
          summaryFilterState.quickFilter.filterByStatus
        }
        projectType={projectType}
        searchCriteria={mapSearchCriteria}
        summaryFilterState={summaryFilterState}
      />
    </>
  );
};

Toolbar.propTypes = {
  client: PropTypes.object
};

export default Toolbar;
